import React, { useState } from 'react';
import { colors, fonts, radius } from './theme';
import { toggleItem } from '../lib/profileFields';

/**
 * Collapsible service-area (territory) picker for one region group.
 * Extracted verbatim from OnboardingFlow's `TerritorySection` (RW-773) so the
 * first-login wizard and the post-onboarding ProfileEditor share one UI and
 * can't drift.
 *
 * Props:
 *   group    — { key, label, areas: string[] } from SERVICE_AREA_GROUPS
 *   selected — string[] of currently-selected areas for this group
 *   onChange — (nextAreas: string[]) => void
 */
export default function ServiceAreaPicker({ group, selected, onChange }) {
  const mobile = typeof window !== 'undefined' && window.matchMedia('(max-width: 900px)').matches;
  const [open, setOpen] = useState(true);
  const count = selected.length;
  const allSelected = group.areas.every((a) => selected.includes(a));

  const toggleAll = () => {
    if (allSelected) onChange([]);
    else onChange([...group.areas]);
  };

  return (
    <div style={{ marginBottom: 12, border: `1px solid ${colors.pearl}`, borderRadius: radius.md, overflow: 'hidden' }}>
      <button type="button" onClick={() => setOpen((v) => !v)}
        style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px 14px', background: colors.pearlLight, border: 'none', cursor: 'pointer', fontFamily: fonts.body }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <input type="checkbox" checked={allSelected} onChange={toggleAll} onClick={(e) => e.stopPropagation()}
            style={{ width: mobile ? 22 : 18, height: mobile ? 22 : 18, accentColor: colors.purple, cursor: 'pointer' }} />
          <span style={{ fontSize: 15, fontWeight: 600, color: colors.noir }}>{group.label}</span>
          {count > 0 ? <span style={{ fontSize: 11, color: colors.purple, fontWeight: 600 }}>({count} selected)</span> : null}
        </div>
        <span style={{ fontSize: 14, color: colors.gray1, transition: 'transform 0.2s', transform: open ? 'rotate(180deg)' : 'rotate(0deg)' }}>▾</span>
      </button>
      {open ? (
        <div style={{ padding: '10px 14px', display: 'flex', flexWrap: 'wrap', gap: 6 }}>
          {group.areas.map((area) => {
            const isSelected = selected.includes(area);
            return (
              <button key={area} type="button" onClick={() => onChange(toggleItem(selected, area))}
                style={{
                  padding: mobile ? '11px 16px' : '7px 14px', minHeight: mobile ? 44 : undefined,
                  borderRadius: 20, fontSize: 13, fontWeight: isSelected ? 600 : 400,
                  fontFamily: fonts.body, cursor: 'pointer', transition: 'all 0.15s',
                  border: `1.5px solid ${isSelected ? colors.purple : colors.pearl}`,
                  background: isSelected ? colors.purple : colors.white,
                  color: isSelected ? colors.white : colors.gray3,
                }}>
                {area}
              </button>
            );
          })}
        </div>
      ) : null}
    </div>
  );
}
